import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { SectionHeading } from '../shared/SectionHeading';

export const TeamSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className="section-shell-muted">
      <div className="section-container">
        <SectionHeading
          align="center"
          eyebrow={t('about.team')}
          title={t('team.title')}
          subtitle={t('team.comingSoon')}
        />
        <div className="mx-auto mt-8 flex max-w-sm items-center justify-center rounded-3xl border border-primary/10 bg-white p-8 shadow-soft">
          <Users className="h-10 w-10 text-primary" />
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
